import { useEffect, useState } from "react";
import api from "../../lib/api";

export default function TabBitacoraFid({ fideicomisoId }) {
    const [rows, setRows] = useState([]);
    useEffect(() => {
        api.get(`/fideicomisos/${fideicomisoId}/bitacora`).then((r) => setRows(r.data));
    }, [fideicomisoId]);

    const shortHash = (h) => (h ? `${h.slice(0, 10)}…${h.slice(-6)}` : "");

    return (
        <div className="pb-16">
            <h2 className="font-display text-2xl mb-3">Bitácora del fideicomiso</h2>
            <p className="text-sm text-muted-foreground mb-4">
                Todas las acciones registradas en este fideicomiso, con hash encadenado.
            </p>
            <div className="rounded-md border border-border overflow-hidden bg-card">
                <table className="trf-table" data-testid="bitacora-fid-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Timestamp</th>
                            <th>Usuario</th>
                            <th>Acción</th>
                            <th>Entidad</th>
                            <th>Cambio</th>
                            <th>Hash</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r) => (
                            <tr key={r.id}>
                                <td className="tabular font-medium">{r.seq}</td>
                                <td className="tabular text-xs">
                                    {r.timestamp?.slice(0, 19).replace("T", " ")}
                                </td>
                                <td className="text-xs">{r.user_email}</td>
                                <td><span className="badge-gold">{r.action}</span></td>
                                <td className="text-xs">
                                    {r.entity_type}
                                    <div className="text-[10px] text-muted-foreground">
                                        {r.entity_id}
                                    </div>
                                </td>
                                <td className="text-xs">
                                    {r.new_value && (
                                        <code className="text-[10px]">
                                            {JSON.stringify(r.new_value).slice(0, 60)}…
                                        </code>
                                    )}
                                </td>
                                <td className="hash-cell">{shortHash(r.current_hash)}</td>
                            </tr>
                        ))}
                        {rows.length === 0 && (
                            <tr>
                                <td colSpan={7} className="text-center py-8 text-muted-foreground">
                                    Sin actividad registrada aún.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
